module.exports = __webpack_public_path__ + "static/media/jacky.dea172eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/aeropost/jacky.jpg
// module id = 1229
// module chunks = 0